import { sharedCoreZh } from "./shared-core";

export const platformSupport = {
  actions: {
    cancel: "取消",
    confirm: "确认",
  },
  common: {
    title: "AIRange",
    locale: "语言",
    phase: "阶段",
    languageChanged: "语言已切换为 {locale}",
  },
  shared: sharedCoreZh,
  shareMode: {
    private: "私有",
    shared_to_users: "定向共享",
    public: "公共",
  },
} as const;
